import {DateTime} from 'luxon';

export class BreadcrumbData {
  customerFirstname!:string;
  customerLastname!:string;
  petName!:string;
  customerId!:string;
  petId!:string;
  treatmentDate!:DateTime;
  treatmentId!:string;
  treatmentTitle!:string;
}
